import { AppBar, Box, Container, Toolbar, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import LogoImg from '../assets/Logo.svg';

const Logo = styled.div`
  cursor: pointer;
  font-size: 24px;

  a {
    max-width: 240px;
    color: black;
    text-decoration: none;
    background: white;
    padding: 8px;
    border: none;
    border-radius: 8px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
  }
`;

const MobileLogo = styled.img`
  display: block;
  width: 48px;
  height: 48px;
  margin-right: 0px;
`;

const DesctopLogo = styled.img`
  display: block;
  width: 48px;
  height: 48px;
  margin-right: 8px;
`;

const Nav = styled.nav`
  @media screen and (max-width: 600px) {
    display: none;
  }
`;

const List = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  margin: 0 16px;

  @media screen and (max-width: 1024px) {
    margin: 0 10px;
  }
`;

const StyledLink = styled(NavLink)`
  padding: 8px;
  color: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;

  svg {
    margin-right: 16px;
  }

  &:hover {
    border-bottom: 2px solid #fff;
  }
`;

const Number = styled.div`
  cursor: pointer;
  background: #199c68;
  border-radius: 32px;

  a {
    padding: 8px;
    color: ${props => (props.path ? '#000' : '#fff')};
    text-decoration: none;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
`;

const Bold = styled.span`
  font-weight: 700;
  font-size: 18px;
  
  @media screen and (max-width:600px) {
    font-size: 16px;
  },
`;

const Header = () => {
  const mobileScreen = useMediaQuery('(max-width:768px)');
  const tabletScreen = useMediaQuery('(max-width:1024px)');
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = newOpen => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar sx={{ boxShadow: 'none' }} position="static">
      <Container maxWidth="lg">
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            padding: '16px 0 !important',
          }}
        >
          <Logo>
            <NavLink to="/">
              {mobileScreen ? (
                <MobileLogo src={LogoImg} alt="Центр юридической помощи" />
              ) : (
                <>
                  <DesctopLogo src={LogoImg} alt="Центр Юридической помощи «Согласие»" />
                  {!tabletScreen && <Typography>Центр Юридической помощи «Согласие»</Typography>}
                </>
              )}
            </NavLink>
          </Logo>
          {mobileScreen ? (
            <MobileMenu toggleDrawer={toggleDrawer} open={open} />
          ) : (
            <>
              <Nav>
                <List>
                  {!tabletScreen && (
                    <ListItem>
                      <StyledLink
                        activeStyle={{
                          fontWeight: 'bold',
                          borderBottom: '2px solid #f6f6f6',
                        }}
                        to="/"
                      >
                        Главная
                      </StyledLink>
                    </ListItem>
                  )}
                  <ListItem>
                    <StyledLink
                      activeStyle={{
                        fontWeight: 'bold',
                        borderBottom: '2px solid #f6f6f6',
                      }}
                      to="/fraud"
                    >
                      Дела о мошенничестве
                    </StyledLink>
                  </ListItem>
                  <ListItem>
                    <StyledLink
                      activeStyle={{
                        fontWeight: 'bold',
                        borderBottom: '2px solid #f6f6f6',
                      }}
                      to="/insurance"
                    >
                      Вопросы страхования
                    </StyledLink>
                  </ListItem>
                  <ListItem>
                    <StyledLink
                      activeStyle={{
                        fontWeight: 'bold',
                        borderBottom: '2px solid #f6f6f6',
                      }}
                      to="/disputes"
                    >
                      Жилищные вопросы
                    </StyledLink>
                  </ListItem>
                </List>
              </Nav>
              <Box>
                <Number>
                  <a href="tel:89150667226">8 915 066 72 26</a>
                </Number>
                <Typography>
                  <Bold>Мы работаем:</Bold>
                  <br /> с 9 до 21, пн-сб.
                </Typography>
              </Box>
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
